/* RESPONSIBLE TEAM: team-inbox-experience */

/**
 * Deduplicates an array of objects by their (objectType, objectId) tuple.
 * Keeps the first occurrence of each unique tuple.
 *
 * Used to prevent 422 unique constraint errors when ember-sortable
 * produces duplicate objects during drag-drop operations. The DB unique
 * index is `(app_id, admin_id, inbox_folder_id, object_type, object_id)`,
 * so `(team, 5)` and `(view, 5)` are legitimately distinct rows — keying
 * on `objectId` alone would silently drop one.
 */
export function deduplicateByObjectKey<T extends { objectType: string; objectId: number }>(
  objects: T[],
): T[] {
  let seen = new Set<string>();
  return objects.filter((obj) => {
    let key = `${obj.objectType}:${obj.objectId}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}
